import React from "react";
import BidderLotDetailsCmp from "./BidderLotDetailsCmp";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {ReduxStateType} from "@nextlot/core/webcast/services/DataStore";
import {ROUND_TYPES_DISPLAY_NAMES_MAP} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {ReduxWebcastStatusType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastStatus";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";


type CmpProps = {
    webcastStatus: ReduxWebcastStatusType,
    currentRound: ReduxWebcastCurrentRoundType,
    lotsMapById: Map<number, Lot>,
}

function BidderCurrentRoundCmp(props: CmpProps) {
    const { t, i18n } = useTranslation();

    const {currentRound, lotsMapById} = props;

    return (
        <div className="bidder-current-round-outline">
            <div className="bidder-cmp bidder-cmp--current-round">
                <div className="cmp__header">
                    <h5 className="m-0">{t('currentRound.nowBidding')}: {ROUND_TYPES_DISPLAY_NAMES_MAP.get(currentRound.roundType)}</h5>
                    {
                        (currentRound.lotsIds.length > 1) &&
                        <div className="pt-1"><strong>{'\u00bb'} &nbsp;{currentRound.lotsIds.length} {t('common.lots')}</strong> &nbsp;<em>({t('currentRound.scrollList')})</em></div>
                    }
                </div>
                <div className="cmp__body">
                    <div className="bidder-current-round__scrollable-list">
                        {
                            currentRound.lotsIds.map((lotId, idx) => {
                                const lot:Lot = lotsMapById.get(lotId);
                                return (
                                    <div key={lotId} className='list-item-container'>
                                        <BidderLotDetailsCmp lot={lot} photoGalleryAutoRotateEverySeconds={4} />

                                        {
                                            (idx < currentRound.lotsIds.length-1) &&
                                            <div className="list-item__vertical-spacer" />
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}

export default connect(({ activeWebcast }:ReduxStateType) => {
    return {
        webcastStatus: activeWebcast.webcastStatus,
        currentRound: activeWebcast.webcastCurrentRound,
        lotsMapById: activeWebcast.webcastAuctionData.lotsMapById,
    };
})(BidderCurrentRoundCmp);
